<script setup lang="ts">
import type { ProductExtra } from "@/schemas/product-extra";

defineProps<{ product: ProductExtra }>();
const { siteOptions } = useSiteOptions();
</script>

<template>
  <section id="product">
    <div class="container space-y-8 py-16">
      <div id="product-details" class="flex flex-col gap-12 lg:flex-row">
        <div class="shrink-0 lg:flex-[0_0_65%]">
          <UiImageGallery v-if="!product.is_gift_card" :images="product.images" />
          <img v-else :src="product.images[0]" class="w-full object-contain">
        </div>
        <div class="flex flex-1 flex-col gap-8">
          <h1 class="h3">
            {{ product.name }}
          </h1>
          <div v-if="!product.is_gift_card" class="">
            <ProductPriceDetailed :product="product" />
            <ProductAskLowerPriceForm :product-id="product.product_id" />
          </div>
          <div class="space-y-1.5">
            <UiCountdown v-if="product.pre_order_timestamp" :timestamp="product.pre_order_timestamp" />
            <ProductStockStatus :product="product" />
            <ProductToggleWishlist :product-id="product.product_id" :show-label="true" />
          </div>
          <div class="mx-4 flex flex-col gap-4 rounded-lg bg-light p-6 lg:mx-0">
            <ProductAddGiftCardForm v-if="product.is_gift_card" :product-id="product.product_id" />
            <ProductAddToCartQuantity v-else-if="product.in_stock" :product="product" />
            <ProductAddToWaitlistForm v-else :product-id="product.product_id" />
            <div class="relative flex min-h-16 items-center">
              <SvgPictoShipping class="absolute -left-14 size-16" />
              <div class="ml-4 text-lg font-medium text-primary" v-html="siteOptions.messages.free_shipping" />
            </div>
            <div class="relative flex min-h-16 items-center">
              <SvgPicto24h class="absolute -left-14 size-16" />
              <div class="ml-4 ">
                <p class="text-lg font-medium text-primary">
                  Commandes traitées en 24h*
                </p>
                <a :href="siteOptions.shipping_url" class="link-primary">* Voir les modalités de transport</a>
              </div>
            </div>
          </div>
          <ProductSpecifications v-if="!product.is_gift_card" :product="product" />
        </div>
      </div>
      <div v-if="$slots.default" id="product-description" class="space-y-4">
        <h2 class="h2 text-primary">
          Description
        </h2>
        <hr class="text-primary">
        <div class="">
          <slot />
        </div>
      </div>
      <div v-if="!product.is_gift_card" id="product-review" class="space-y-4">
        <div class="flex items-center gap-2">
          <h2 class="h2 text-primary">
            Avis
          </h2>
          <div class="mt-1 text-lg text-muted">
            ({{ product.reviews.length }})
          </div>
        </div>
        <hr class="text-primary">
        <ProductSubmitReviewForm :product-id="product.product_id" />
        <ProductReviews :reviews="product.reviews" />
      </div>
    </div>
  </section>
</template>
